import React from 'react'

// components
import {
  CRow
} from '@coreui/react-pro'
import AppTextColumnDetails from '../general-details/AppTextColumnDetails'

const AppDetails = ({
  companyPolicyDetails,
}) => {
  return (
    <>
      <CRow className='mb-4'>
        <AppTextColumnDetails
          colSize="3"
          title="Company Policy Name"
          className='mb-3'
          subtitle={companyPolicyDetails?.name ? companyPolicyDetails?.name : '-'}
        />
        <AppTextColumnDetails
          colSize="3"
          title="Company Policy Number"
          className='mb-3'
          subtitle={companyPolicyDetails?.number ? companyPolicyDetails?.number : '-'}
        />
        <AppTextColumnDetails
          colSize="3"
          title="Company Policy Description"
          className='mb-3'
          subtitle={companyPolicyDetails?.description ? companyPolicyDetails?.description : '-'}
        />
        <AppTextColumnDetails
          colSize="3"
          title="Company Policy Type"
          className='mb-3'
          subtitle={companyPolicyDetails?.policy_type?.name ? companyPolicyDetails?.policy_type?.name : '-'}
        />
        <AppTextColumnDetails
          colSize="3"
          title="Company Policy Status"
          className='mb-3'
          subtitle={companyPolicyDetails?.is_published ? 'Published' : 'Draft'}
        />
      </CRow>
    </>
  )
}

export default AppDetails
